import { Info, StatusCellRenderer, UnitDetailsRenderer } from "./GridFrameworks";

export const columnDef = [
    {
        headerName: "",
        field: "Id",
        cellRenderer: Info,
        width: 60,
    },
    {
        field: "ProductName",
        headerName: "Product Name",
        flex: 1,
        minWidth: 200,
    },
    {
        field: "ManufacturerName",
        headerName: "Manufacturer",
        minWidth: 150,
    },
    {
        field: "CategoryName",
        headerName: "Category",
        minWidth: 120,
    },
    {
        field: "SupplierUnitType",
        headerName: "Unit Details",
        flex: 1,
        minWidth: 200,
        cellRenderer: UnitDetailsRenderer,
    },
    {
        field: "UnitsAvailable",
        headerName: "Available",
        minWidth: 100,
    },
    {
        field: "MinOrderQuantity",
        headerName: "Min Order",
        minWidth: 100,
    },
];
